export default {"src":"/org/_next/static/media/app-store-small.b855c5b4.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};